<template>
  <v-app>
    <v-app-bar app color="white" height="75">
      <div class="container d-flex align-center">
        <nuxt-link to="/">
          <img
            src="/customers/florida/logo.png"
            style="height: 65px; width: auto; display: flex"
          />
        </nuxt-link>

        <v-toolbar-title
          class="font-weight-black ml-4 flex-column text-center d-none d-lg-flex"
          style="font-size: 1.15rem; letter-spacing: 0.05rem"
        >
          Florida Forest Service
          <div
            style="font-weight: 300; font-size: 1rem; letter-spacing: 0.25rem"
          >
            fiResponse
          </div>
        </v-toolbar-title>

        <v-spacer />
        <v-app-bar-nav-icon
          class="d-flex d-sm-none"
          @click.stop="drawer = !drawer"
        />
        <v-btn text nuxt to="/" class="d-none mx-1 d-sm-flex"> Home </v-btn>
        <v-btn text nuxt to="/about" class="d-none mx-1 d-sm-flex">
          About
        </v-btn>
        <!-- <v-btn text nuxt to="/support" class="d-none mx-1 d-sm-flex">
          Support
        </v-btn> -->
        <v-btn text nuxt to="/contact" class="d-none ml-1 mr-4 d-sm-flex">
          Contact
        </v-btn>
        <client-only>
          <v-btn
            v-if="$auth.user"
            class="mr-4 font-weight-black d-none d-sm-flex"
            text
            nuxt
            to="/apps"
          >
            Apps
          </v-btn>
          <v-divider
            vertical
            style="max-height: 81px !important"
            class="d-none d-sm-flex"
          />
          <v-btn
            v-if="!$auth.user"
            class="ml-4 font-weight-black d-none d-sm-flex accent"
            text
            nuxt
            to="login"
          >
            Sign In
          </v-btn>
          <v-btn
            v-else
            class="ml-4 font-weight-black d-none d-sm-flex"
            text
            @click="$auth.logout()"
          >
            Sign Out
          </v-btn>
        </client-only>
      </div>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app temporary>
      <v-list nav dense>
        <v-list-item-group active-class="primary--text text--accent-4">
          <v-list-item nuxt to="/">
            <v-list-item-title> Home </v-list-item-title>
          </v-list-item>

          <v-list-item nuxt to="/about">
            <v-list-item-title> About </v-list-item-title>
          </v-list-item>

          <v-list-item nuxt to="/support">
            <v-list-item-title> Support </v-list-item-title>
          </v-list-item>

          <v-list-item nuxt to="/contact">
            <v-list-item-title> Contact </v-list-item-title>
          </v-list-item>

          <client-only>
            <v-divider />
            <v-list-item v-if="$auth.user" nuxt to="/apps">
              <v-list-item-title> Apps </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!$auth.user" nuxt to="/login">
              <v-list-item-title>Sign In</v-list-item-title>
            </v-list-item>
            <v-list-item v-else @click="$auth.logout()">
              <v-list-item-title>Sign Out</v-list-item-title>
            </v-list-item>
          </client-only>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <nuxt />
    </v-main>
    <disclaimer
      :show="showDisclaimerDialog"
      @close="showDisclaimerDialog = false"
    />
    <component :is="footer" @showdisc="showDisclaimerDialog = true" />
    <snackbar />
  </v-app>
</template>

<script>
import Snackbar from "@/components/Snackbar";
import Disclaimer from "@/components/bycustomer/modaldisclaimer/florida.vue";
import Footer from "@/components/bycustomer/footer/florida.vue";

export default {
  components: { Snackbar, Disclaimer, Footer },
  data({ $config }) {
    return {
      showDisclaimerDialog: false,
      drawer: false,
      customer: $config.CUSTOMER,
      footer: Footer,
    };
  },
  mounted() {
    setTimeout(() => {
      const disclaimer = localStorage.getItem("DisclaimerDialog");
      if (!disclaimer) this.showDisclaimerDialog = true;
    }, 500);
  },
};
</script>

<style>
.portal-hero {
  min-height: 50vh;
  background-size: cover;
}

.container.portal-section {
  padding: 5em 0;
  background-size: cover;
}
</style>
